(ns manage.adset-activation-page.view.page
  (:require ["@mui/material/Button$default" :as Button]
            [common.widgets.page :as page]
            [manage.adset-activation-page.view.activation-panel :refer [sync-details-panel]]
            [manage.adset-activation-table.view :refer [activation-data-grid]]
            [manage.resource.adset-activation :as resource]
            [re-frame.core :as rf]
            [uix.core :refer [$] :as uix]))

(defn adset-activation-page [_]
  (uix/use-effect (fn []
                    (rf/dispatch [:table.adset-activation/init]))
                  [])
  ($ page/page
     ($ page/page-header
        {:title "Activation"
         :buttons ($ :<>
                     ($ Button
                        {:onClick (fn [_]
                                    (js/Promise.
                                     (fn [resolve reject]
                                       (rf/dispatch [::resource/init-activation resolve reject]))))
                         :variant "contained"}
                        "Init")
                     ($ Button
                        {:onClick (fn [_]
                                    (js/Promise.
                                     (fn [resolve reject]
                                       (rf/dispatch [::resource/sync-activation resolve reject]))))
                         :variant "contained"}
                        "Sync"))})
     ($ page/content-padding
        {:sx #js {:overflow "hidden"}}
        ($ sync-details-panel)
        ($ activation-data-grid))))
